"use client"

import { Files } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FilesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FilesIcon = component(Icon)({ as: Files })
